import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@gumtree/ui-library';
import { trackGA4AndNavigate } from '@gumtree/shared/src/util/ga4-shared';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';
import { getClickListingDetails } from '@gumtree/shared/src/util/listing-details';
import { ModernTopSearchesContainer, VotTopSearchesContainer } from './top-search-modern.style';

const TopSearchCondensed = ({ topSearchCondensed, modern = false, vot = false }) => {
    const content = (
        <ul className="link-list">
            {topSearchCondensed[0].items.map((el, index) => (
                <li className="item" key={el.name + index}>
                    <Link
                        text={el.name}
                        dataQ="top-searches-link"
                        className="link"
                        href={el.url}
                        onClick={(e) => {
                            trackGA4AndNavigate({
                                href: el.url,
                                mouseEvent: e,
                                payload: {
                                    event: 'link_click',
                                    linkDomain: getLinkHostname(el.url),
                                    linkText: el.name,
                                    linkType: 'inside',
                                    linkURL: el.url,
                                    linkLocation: 'topSearches',
                                    linkPosition: index + 1,
                                    listLinkDetail: getClickListingDetails(),
                                    linkDetail: {},
                                },
                            });
                        }}
                    />
                </li>
            ))}
        </ul>
    );

    if (vot) {
        return (
            <VotTopSearchesContainer className="vot-browse-links-content">
                {content}
            </VotTopSearchesContainer>
        );
    }

    return modern ? (
        <ModernTopSearchesContainer>
            <h2>{topSearchCondensed[0].title}</h2>
            {content}
        </ModernTopSearchesContainer>
    ) : (
        content
    );
};

TopSearchCondensed.propTypes = {
    topSearchCondensed: PropTypes.array.isRequired,
    modern: PropTypes.bool,
    vot: PropTypes.bool,
};

export default TopSearchCondensed;
